import { getFinance, getOperation, putFinance, putOperation } from "utils/api";

export const getPayfac = async (id) => {
  return await getOperation(`/payfac/${id}`);
};

export const updatePayfac = async (id, payload) => {
  return await putOperation(`/payfac/${id}`, payload);
};

export const queryPayfacAgents = async (params) => {
  return await getOperation("/agent", {
    sort: "createdDate,desc",
    ...params,
  });
};

export const getBankInfoConfig = async (payfacId) => {
  return await getFinance(`/bank-info-config/${payfacId}`);
};

export const updateBankInfoConfig = async (payfacId, payload) => {
  return await putFinance(`/bank-info-config/${payfacId}`, payload);
};
